// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* based on the "color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#3b3b35",
        contrast: "#ffffff",
        light: "#f8f8f8",
        dark: "#202020",
    },
    secondary: {
        main: "#865f32",
        contrast: "#ffffff",
        light: "#f5f2ee",
        dark: "#554b38",
    },
    tertiary: {
        main: "#508692",
        contrast: "#ffffff",
        light: "#ccd9db",
        dark: "#49626a",
    },
    common: {
        border: "#e3e3e3",
        borderLight: "#4d5054",
        borderDark: "#989da5",
        accent: "#f8f8f8",
        accentContrast: "#353538",
        accentContrastLight: "#4d5054",
        background: "#ffffff",
        backgroundContrast: "#353538",
        disabled: "#f8f8f8",
        disabledDark: "#e9edf0",
    },
    text: {
        main: "#353538",
        accent: "#505255",
        disabled: "#6d6d6d",
        disabledLight: "#979797", // Store Custom Code
        link: "#865f32",
        linkHover: "#865f32",
        linkAlt: "#353538",
        linkAltHover: "#3b3b35",
        input: "#353538",
        semi: "#7c7d7f", // Store Custom Code
    },
    success: {
        main: "#29996a",
        contrast: "#ffffff",
        light: "#eff8f2",
    },
    warning: {
        main: "#af5c18",
        contrast: "#ffffff",
        light: "#fff7f1",
    },
    danger: {
        main: "#db0505",
        contrast: "#ffffff",
        light: "#fff5f7",
    },
    info: {
        main: "#1875af",
        contrast: "#ffffff",
        light: "#edf5ff",
    },
    neutral: {
        main: "#666666",
        contrast: "#ffffff",
        light: "#e0e0e0",
    },
    invert: {
        main: "#ffffff",
        contrast: "#353538",
        hover: "#202020",
        dark: "#f8f8f8",
    },
    placeholder: {
        main: "#979797",
        disabled: "#d6d7dc",
    },
    button: {
        disabled: {
            main: "#dcdcdc",
            contrast: "#6d6d6d",
        },
    },
    header: {
        main: "#ffffff",
        contrast: "#353538",
        hover: "#353538",
        accent: "#353538",
        accentHover: "#3b3b35",
        accentContrast: "#ffffff",
    },
    menu: {
        mainNavigation: {
            main: "#ffffff",
            contrast: "#353538",
            hover: "#865f32",
            underline: "#865f32",
            accent: "#353538",
            accentContrast: "#ffffff",
            accentHover: "#865f32",
            separator: "#e3e3e3",
            border: "#e3e3e3",
        },
        secondaryNavigation: {
            main: "#f5f2ee",
            contrast: "#865f32",
            hover: "#865f32",
        },
        megaMenuWithTabs: {
            tabsBackground: "#f8f8f8",
            tabsBackgroundHover: "#ffffff",
        },
    },
    footer: {
        main: "#3b3b35",
        contrast: "#eeeeee",
        alt: "#3b3b35",
        altContrast: "#eeeeee",
    },
    swatch: {
        main: "#e3e3e3",
        contrast: "#353538",
        hover: "#989da5",
        selected: "#3b3b35",
        selectedHover: "#3b3b35",
    },
    /* Store Custom Code - Start */
    eByEmserBadge: {
        backgroundColor: "#1c1c1c",
        labelColor: "#ffbd56",
    },
    // prettier-ignore
    cssFilter: {
        "#865f32": "brightness(0) saturate(100%) invert(35%) sepia(33%) saturate(764%) hue-rotate(352deg) brightness(101%) contrast(86%)",
        "#353538": "brightness(0) saturate(100%) invert(19%) sepia(4%) saturate(456%) hue-rotate(202deg) brightness(96%) contrast(93%)",
        "#e3e3e3": "brightness(0) saturate(100%) invert(100%) sepia(86%) saturate(641%) hue-rotate(227deg) brightness(121%) contrast(78%)",
        "#3b3b35": "brightness(0) saturate(100%) invert(19%) sepia(9%) saturate(505%) hue-rotate(21deg) brightness(92%) contrast(84%)",
        "#989da5": "brightness(0) saturate(100%) invert(67%) sepia(8%) saturate(269%) hue-rotate(178deg) brightness(92%) contrast(89%)",
        "#eeeeee": "brightness(0) saturate(100%) invert(98%) sepia(36%) saturate(94%) hue-rotate(187deg) brightness(113%) contrast(87%)",
        "#f5f2ee": "brightness(0) saturate(100%) invert(96%) sepia(82%) saturate(234%) hue-rotate(294deg) brightness(105%) contrast(92%)",
        "#ffffff": "brightness(0) saturate(100%) invert(100%) sepia(1%) saturate(115%) hue-rotate(266deg) brightness(115%) contrast(100%)",
        "#6d6d6d": "brightness(0) saturate(100%) invert(39%) sepia(0%) saturate(1598%) hue-rotate(145deg) brightness(105%) contrast(86%)",
        "#dcdcdc": "brightness(0) saturate(100%) invert(99%) sepia(2%) saturate(2309%) hue-rotate(183deg) brightness(109%) contrast(73%)",
        "#d6d7dc": "brightness(0) saturate(100%) invert(93%) sepia(8%) saturate(114%) hue-rotate(193deg) brightness(99%) contrast(79%)",
        "#979797": "brightness(0) saturate(100%) invert(67%) sepia(0%) saturate(0%) hue-rotate(54deg) brightness(91%) contrast(88%)",
        "#f8f8f8": "brightness(0) saturate(100%) invert(100%) sepia(68%) saturate(3%) hue-rotate(16deg) brightness(103%) contrast(95%)",
        "#202020": "brightness(0) saturate(100%) invert(12%) sepia(9%) saturate(0%) hue-rotate(168deg) brightness(103%) contrast(99%)",
        "#e0e0e0": "brightness(0) saturate(100%) invert(100%) sepia(7%) saturate(127%) hue-rotate(8deg) brightness(110%) contrast(76%)",
        "#666666": "brightness(0) saturate(100%) invert(42%) sepia(0%) saturate(720%) hue-rotate(182deg) brightness(91%) contrast(85%)",
        "#edf5ff": "brightness(0) saturate(100%) invert(88%) sepia(2%) saturate(2325%) hue-rotate(191deg) brightness(106%) contrast(105%)",
        "#1875af": "brightness(0) saturate(100%) invert(34%) sepia(87%) saturate(682%) hue-rotate(166deg) brightness(95%) contrast(91%)",
        "#fff5f7": "brightness(0) saturate(100%) invert(79%) sepia(34%) saturate(98%) hue-rotate(306deg) brightness(115%) contrast(101%)",
        "#db0505": "brightness(0) saturate(100%) invert(17%) sepia(80%) saturate(6997%) hue-rotate(356deg) brightness(84%) contrast(106%)",
        "#fff7f1": "brightness(0) saturate(100%) invert(98%) sepia(23%) saturate(588%) hue-rotate(295deg) brightness(102%) contrast(102%)",
        "#af5c18": "brightness(0) saturate(100%) invert(37%) sepia(84%) saturate(640%) hue-rotate(350deg) brightness(90%) contrast(90%)",
        "#eff8f2": "brightness(0) saturate(100%) invert(94%) sepia(6%) saturate(282%) hue-rotate(81deg) brightness(106%) contrast(95%)",
        "#29996a": "brightness(0) saturate(100%) invert(56%) sepia(10%) saturate(2805%) hue-rotate(103deg) brightness(86%) contrast(84%)",
        "#7c7d7f": "brightness(0) saturate(100%) invert(52%) sepia(6%) saturate(109%) hue-rotate(181deg) brightness(94%) contrast(94%)",
        "#505255": "brightness(0) saturate(100%) invert(33%) sepia(5%) saturate(282%) hue-rotate(177deg) brightness(96%) contrast(97%)",
        "#e9edf0": "brightness(0) saturate(100%) invert(86%) sepia(11%) saturate(67%) hue-rotate(163deg) brightness(110%) contrast(90%)",
        "#4d5054": "brightness(0) saturate(100%) invert(31%) sepia(3%) saturate(732%) hue-rotate(175deg) brightness(93%) contrast(89%)",
        "#49626a": "brightness(0) saturate(100%) invert(38%) sepia(21%) saturate(418%) hue-rotate(148deg) brightness(93%) contrast(98%)",
        "#ccd9db": "brightness(0) saturate(100%) invert(91%) sepia(11%) saturate(163%) hue-rotate(140deg) brightness(94%) contrast(91%)",
        "#508692": "brightness(0) saturate(100%) invert(51%) sepia(27%) saturate(548%) hue-rotate(144deg) brightness(90%) contrast(91%)",
        "#554b38": "brightness(0) saturate(100%) invert(26%) sepia(15%) saturate(870%) hue-rotate(1deg) brightness(95%) contrast(85%)",
    },
    /* Store Custom Code - End */
};

export default colors;
